// a canactivate guard that checks if the environment allows admin access

import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from "@angular/router";
import { inject } from "@angular/core";
import { NavigationService } from "../services/navigation.service";
import { AdminAuthService } from "../services/admin-auth.service";

export const AdminGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const adminService: AdminAuthService = inject(AdminAuthService);
    const navigationService: NavigationService = inject(NavigationService);
    if(adminService.haveAdminAccess) {
        return true;
    }
    else {
        navigationService.setMessage('404').navigateToErrorPage();
        return false;
    }
}